<template>
  <ib-application setupSSO setViewportMeta>
    <MarketRulesTable :exchange-conids="moduleProps.exchangeConids" @close="close" />
  </ib-application>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { app } from '@ibgroup-tws-webapps/ratio.ui';
import MarketRulesTable from './MarketRulesTable.vue';
import type { ExchangeConid } from './MarketRulesTable.vue';

const moduleProps = inject<{
  exchangeConids: ExchangeConid[];
  authenticated?: boolean;
  accountId?: string;
}>('moduleProps', {
  exchangeConids: [],
  authenticated: false,
  accountId: '',
});

function close() {
  app.send({ action: 'back', data: { exit: true } });
}
</script>
